export function safeNumber(value, fallback = 0) {
  const number = Number(value);

  return Number.isFinite(number) ? number : fallback;
}

export function formatTutorialDate(value) {
  if (!value) {
    return "—";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "—";
  }

  return new Intl.DateTimeFormat("fr-FR", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
}

export function getTutorialScopeLabel(tutorial) {
  if (!tutorial?.site_key) {
    return "Tous les sites";
  }

  return tutorial.site_key;
}

export function getTutorialStatusLabel(status) {
  switch (status) {
    case "publie":
      return "Publié";

    case "archive":
      return "Archivé";

    case "brouillon":
    default:
      return "Brouillon";
  }
}

export function getTutorialStatusTone(status) {
  switch (status) {
    case "publie":
      return "green";

    case "archive":
      return "gray";

    case "brouillon":
    default:
      return "orange";
  }
}

export function buildTutorialSearchText(tutorial) {
  return [
    tutorial?.id,
    tutorial?.titre,
    tutorial?.sous_titre,
    tutorial?.app_key,
    tutorial?.site_key,
    tutorial?.locale,
    tutorial?.version,
    tutorial?.statut,
  ]
    .filter(
      (value) =>
        value !== null &&
        value !== undefined &&
        value !== ""
    )
    .join(" ")
    .toLowerCase();
}

export function normalizeTutorialForm(tutorial) {
  return {
    app_key: tutorial?.app_key || "monappli-club",
    site_key: tutorial?.site_key || "",
    locale: tutorial?.locale || "fr-FR",
    version: tutorial?.version || 1,

    titre: tutorial?.titre || "",
    sous_titre: tutorial?.sous_titre || "",

    intro_label: tutorial?.intro_label || "Bienvenue",
    intro_titre:
      tutorial?.intro_titre || "Bienvenue sur MonAppliClub",
    intro_contenu: tutorial?.intro_contenu || "",

    faq_label:
      tutorial?.faq_label || "Questions fréquentes",
    faq_titre:
      tutorial?.faq_titre || "Questions fréquentes",

    afficher_feedback:
      tutorial?.afficher_feedback !== false,

    feedback_question:
      tutorial?.feedback_question ||
      "Ce tutoriel vous a-t-il aidé ?",

    feedback_description:
      tutorial?.feedback_description || "",

    support_titre:
      tutorial?.support_titre || "Besoin d’aide ?",

    support_description:
      tutorial?.support_description || "",

    support_nom: tutorial?.support_nom || "",
    support_email: tutorial?.support_email || "",
    support_telephone: tutorial?.support_telephone || "",

    is_active: tutorial?.is_active !== false,
  };
}